import { createWebHashHistory, createRouter } from 'vue-router'
import store from '@/store/store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/login'),
  },
  {
    path: '/',
    name: 'dashboard',
    component: () => import('../components/dashbaord'),
    meta: { auth: true }
  },
  {
    path: '/obras',
    name: 'obras',
    component: () => import('../components/obras/obras'),
    meta: { auth: true }
  },
  {
    path: '/guias',
    name: 'guias',
    component: () => import('../components/guias/guias'),
    meta: { auth: true }
  },
  {
    path: '/stocks',
    name: 'stocks',
    component: () => import('../components/stocks/stocks'),
    meta: { auth: true }
  },
  {
    path: '/obra/:id',
    name: 'obra',
    component: () => import('../components/obras/obra'),
    meta: { auth: true }
  },
  {
    path: '/materiais',
    name: 'materiais',
    component: () => import('../components/materiais/materiais'),
    meta: { auth: true }
  },
  {
    path: '/unidades',
    name: 'unidades',
    component: () => import('../components/unidades/unidades'),
    meta: { auth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    const { isUserLoggedIn, token, logTime } = store.state

    if (!isUserLoggedIn || !token) {
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }
    //expirar após 12 horas
    if (!logTime || Date.now() - logTime >= 43200000) {
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }

  next()
})

export default router